import {normaliseFuelTypes} from './fuel-types.js';

export const CapabilityAnswer=Object.freeze({
  UNKNOWN:'unknown',
  YES:'yes',
  NO:'no'
});

export const TemperatureControl=Object.freeze({
  UNKNOWN:'unknown',
  MANUAL:'manual',
  REGULATED:'regulated',
  AUTOMATIC:'automatic'
});

const ANSWERS=new Set(Object.values(CapabilityAnswer));
const CONTROLS=new Set(Object.values(TemperatureControl));

function nullableNumber(value,label,{min=-50,max=500}={}){
  if(value==null||value==='')return null;
  const number=Number(value);
  if(!Number.isFinite(number)||number<min||number>max)throw new TypeError(`${label} is out of range`);
  return number;
}

export function createSmokerCapabilities({
  smokerId,
  fuelTypes=[],
  minTemperatureCelsius=null,
  maxTemperatureCelsius=null,
  coldSmoking=CapabilityAnswer.UNKNOWN,
  coldSmokeMaxCelsius=null,
  temperatureControl=TemperatureControl.UNKNOWN,
  controlPrecisionCelsius=null
}={}){
  const id=String(smokerId||'').trim();
  if(!id)throw new TypeError('smokerId is required');

  const minTemp=nullableNumber(minTemperatureCelsius,'minTemperatureCelsius');
  const maxTemp=nullableNumber(maxTemperatureCelsius,'maxTemperatureCelsius');
  if(minTemp!==null&&maxTemp!==null&&minTemp>maxTemp){
    throw new TypeError('minTemperatureCelsius cannot exceed maxTemperatureCelsius');
  }

  const cold=String(coldSmoking||'').toLowerCase();
  if(!ANSWERS.has(cold))throw new TypeError('Unsupported coldSmoking value');

  const coldMax=nullableNumber(coldSmokeMaxCelsius,'coldSmokeMaxCelsius');
  if(cold===CapabilityAnswer.NO&&coldMax!==null)throw new TypeError('coldSmokeMaxCelsius requires cold smoking support');
  if(coldMax!==null&&maxTemp!==null&&coldMax>maxTemp)throw new TypeError('coldSmokeMaxCelsius cannot exceed maxTemperatureCelsius');

  const control=String(temperatureControl||'').toLowerCase();
  if(!CONTROLS.has(control))throw new TypeError('Unsupported temperatureControl value');

  const precision=nullableNumber(controlPrecisionCelsius,'controlPrecisionCelsius',{min:0,max:100});
  if(control===TemperatureControl.UNKNOWN&&precision!==null){
    throw new TypeError('controlPrecisionCelsius requires known temperature control');
  }

  return Object.freeze({
    smokerId:id,
    fuelTypes:normaliseFuelTypes(fuelTypes),
    minTemperatureCelsius:minTemp,
    maxTemperatureCelsius:maxTemp,
    coldSmoking:cold,
    coldSmokeMaxCelsius:coldMax,
    temperatureControl:control,
    controlPrecisionCelsius:precision
  });
}

export function smokerCapabilitiesToRow(value){
  const c=createSmokerCapabilities(value);
  return Object.freeze({
    smoker_id:c.smokerId,
    fuel_types:[...c.fuelTypes],
    min_temperature_c:c.minTemperatureCelsius,
    max_temperature_c:c.maxTemperatureCelsius,
    cold_smoking:c.coldSmoking,
    cold_smoke_max_c:c.coldSmokeMaxCelsius,
    temperature_control:c.temperatureControl,
    control_precision_c:c.controlPrecisionCelsius
  });
}

export function smokerCapabilitiesFromRow(row={}){
  return createSmokerCapabilities({
    smokerId:row.smoker_id,
    fuelTypes:row.fuel_types,
    minTemperatureCelsius:row.min_temperature_c,
    maxTemperatureCelsius:row.max_temperature_c,
    coldSmoking:row.cold_smoking,
    coldSmokeMaxCelsius:row.cold_smoke_max_c,
    temperatureControl:row.temperature_control,
    controlPrecisionCelsius:row.control_precision_c
  });
}
